module.exports = __webpack_public_path__ + "static/OneDot-Bold.ebd8c732.eot";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDot-Bold.eot
// module id = 729
// module chunks = 114276838955818